import { StyleSheet } from 'react-native';

export const alertStyles = StyleSheet.create({
	dialog: {
		alignSelf: 'center',
		borderRadius: 12,
		elevation: 8,
		shadowColor: '#000',
		shadowOffset: {
			width: 0,
			height: 4,
		},
		shadowOpacity: 0.15,
		shadowRadius: 8,
	},
	mobileDialog: {
		marginHorizontal: 16,
		maxWidth: '100%',
		width: '100%',
	},
	desktopDialog: {
		margin: 0,
		padding: 0,
		width: 600,
		maxWidth: 800,
	},
	button: {
		marginTop: 8,
		marginBottom: 0,
	},
});
